import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { map, of } from 'rxjs';
import { LegalAcceptanceService } from './legal-acceptance.service';
import { LEGAL_ACCEPT_URL } from './legal.constants';

/**
 * Acceptance gate (L6, L7): while the signed-in user has legal documents to accept,
 * every admin and user page sends them to `/legal/accept?redirectURL=<where they were going>`.
 *
 * Use it in `canActivateChild` of a tree whose `canActivate` is `AuthGuard`: guards in
 * one array run concurrently, so the session must already be settled when this runs.
 * The acceptance page and the documents live outside those trees, so there is no loop.
 */
export const LegalAcceptanceGuard: CanActivateFn | CanActivateChildFn = (_route, state) => {
    // No session: nothing to ask the API; AuthGuard sends the visitor to sign-in.
    if (!inject(AuthService).accessToken) {
        return of(true);
    }

    const router = inject(Router);

    return inject(LegalAcceptanceService)
        .pending()
        .pipe(
            map((pending) =>
                pending.length
                    ? router.createUrlTree([LEGAL_ACCEPT_URL], { queryParams: { redirectURL: state.url } })
                    : true
            )
        );
};
